import React, { Fragment, useEffect } from 'react'
// import axios from 'axios';
import { Linkedin, Instagram, Twitter } from 'react-feather';
import { Link } from "react-router-dom";
// import { MenuURL } from '../helper/helper';
import Logo from '../assets/images/logo.svg';

const Footer = () => {
  // const [loading, setLoading] = useState(false);
  // const [contactEmail, setContactEmail] = useState('');
  // const [address, setAddress] = useState('');
  // const [social, setSocial] = useState('');
  // const [copyright, setCopyright] = useState('');
  // const [privacy, setPrivacy] = useState('');
  
  // const contactEmailURL = `${MenuURL}/7`;
  // const addressURL = `${MenuURL}/7`;
  // const socialURL = `${MenuURL}/8`;
  // const copyrightURL = `${MenuURL}/9`;
  // const privacyURL = `${MenuURL}/10`;

  useEffect(() => {
    // axios.get(contactEmailURL)
    //   .then(response => {
    //     setContactEmail(response.data.items[0].title);
    //     setLoading(true);
    //   });

    // axios.get(addressURL)
    //   .then(response => {
    //     setAddress(response.data.items[1].title);
    //     setLoading(true);
    //   });

    // axios.get(socialURL)
    //   .then(response => {
    //     setSocial(response.data.items);
    //     setLoading(true);
    //   });

    // axios.get(copyrightURL)
    //   .then(response => {
    //     setCopyright(response.data.items[0].title);
    //     setLoading(true);
    //   });
      
    //   axios.get(privacyURL)
    //   .then(response => {
    //     setPrivacy(response.data.items[0].title);
    //     setLoading(true);
    //   });

  }, [])

  return (
    <Fragment>
      <section id='footer'>
        <div className='footer'>
          <div className='footer__left'>
            {/* <h2 className='heading3 white'>Get <span className='secondary-color'>in touch</span></h2> */}
            <Link to="/">
              <img src={Logo} alt='Logo'/>
            </Link>
          </div>

          <div className='footer__center'>
            <div className='footer__center-menu'>
              <ul>
                <li><Link to='/'>Home</Link></li>
                <li><Link to='/about-us'>About us</Link></li>
                <li><Link to='/services'>Services</Link></li>
                <li><Link to='/our-culture'>Our Culture</Link></li>
                {/* <li className='ot-sdk-show-settings'>Cookie Settings</li> */}
              </ul>
            </div>
            <div className='footer__center-menu'>
              <ul>
                <li><Link to='/our-work'>Our Work</Link></li>
                <li><Link to='/contact-us'>Contact Us</Link></li>
                <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                <li><Link to='/terms-and-conditions'>Terms & Conditions</Link></li>
              </ul>
            </div>
          </div>

          <div className='footer__right'>
            <div className='footer__right-menu'>
              <ul>
                <li><a href="mailto:business@mslgroup.com">business@mslgroup.com</a></li>
                <li>
                  <a href='https://goo.gl/maps/5PB1mQWxv2VS3xU27' target={'_blank'} rel="noreferrer">211, Okhla Phase III, Okhla Industrial Estate, New Delhi, Delhi - 110020.</a>
                </li>
                <li>
                  <ul className='footer__social'>
                    <a href="https://www.linkedin.com/company/organic-by-msl/" target="_blank" rel="noopener noreferrer"><Linkedin/></a>
                    <a href="https://twitter.com/OrganicByMSL" target="_blank" rel="noopener noreferrer"><Twitter/></a>
                    <a href="https://www.instagram.com/organicbymsl/" target="_blank" rel="noopener noreferrer"><Instagram/></a>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id='copyright'>
        <div className='copyright'>
        {/* <p>{loading ? copyright : 'Loading...'}</p> */}
          <p>Copyright 2023 Organic by MSL | All Rights Reserved.</p>
        </div>
      </section>
    </Fragment>
  )
}

export default Footer;
